module.exports = __webpack_public_path__ + "dash_20_app_assets/img/GN.e93404a6.png";